/* eslint-disable no-console */

import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  // Increment the version whenever you want to force a cache update
  const cacheVersion = 'v4.3';

  register(`${process.env.BASE_URL}service-worker.js?v=${cacheVersion}`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      );
    },
    registered(registration) {
      console.log('Service worker has been registered.');
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated(registration) {
      console.log('New content is available; please refresh.');

      // Dispatch event FIRST so UI can show notification before any reload
      // The UI components will handle triggering SKIP_WAITING when user confirms
      if (registration.waiting) {
        document.dispatchEvent(
          new CustomEvent('serviceWorkerUpdateEvent', { detail: registration })
        );
      }
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });
}